import { _decorator, UIRenderer } from 'cc';
import BaseShaderManipulator from './BaseShaderManipulator';

const { ccclass, executeInEditMode } = _decorator;

@ccclass('ShaderManipulator')
@executeInEditMode
export default abstract class ShaderManipulator extends BaseShaderManipulator {
    protected _target: UIRenderer = null;

    protected get target(): UIRenderer {
        return super.target as UIRenderer;
    }

    protected findTarget() {
        const target = this.getComponent(UIRenderer);
        if (!target) {
            throw new Error(`Can't find target component.`);
        }
        return target;
    }
}
